import { COLORS, TYPO } from '@/b2b/shared/consts';
import { Whatsapp24 } from '@/b2b/shared/icons';
import { BreakpointsEnum } from '@/b2b/shared/types';
import { UiFlex } from '@/b2b/shared/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { LinksColumn } from './linksColumn';

interface Contact {
  url: string;
  text: string;
  subText?: string;
  target?: string;
}

interface Props {
  emailToSupport?: Contact;
  linkToSupport?: Contact;
  buttonPosition?: 'top' | 'bottom';
}

export const ServiceBlock: FC<Props> = ({ emailToSupport, linkToSupport, buttonPosition = 'bottom' }) => {
  const emailLinks = emailToSupport ? [emailToSupport] : [];

  return (
    <LinksColumn
      links={emailLinks}
      slotPosition={buttonPosition}
      title="Служба поддержки"
    >
      <ButtonContainer
        direction="column"
        gap={0}
      >
        <SupportLink
          href={linkToSupport?.url}
          target="_blank"
          $buttonPosition={buttonPosition}
        >
          <SupportButton>
            <Whatsapp24 />
            {linkToSupport?.text}
          </SupportButton>
        </SupportLink>
        {linkToSupport?.subText && <SubText>{linkToSupport.subText}</SubText>}
      </ButtonContainer>
    </LinksColumn>
  );
};

const ButtonContainer = styled(UiFlex)``;

const SupportLink = styled.a<{ $buttonPosition: 'top' | 'bottom' }>`
  width: 100%;
  text-decoration: none;
  margin-top: ${({ $buttonPosition }) => ($buttonPosition === 'top' ? '0' : '8px')};

  @media (min-width: ${BreakpointsEnum.lgm}px) {
    width: auto;
    margin-top: 0;
  }
`;

const SupportButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 24px;
  border-radius: 24px;
  background-color: ${COLORS.grayscale50};
  color: ${COLORS.black};
  cursor: pointer;
  ${TYPO.body2}

  &:hover {
    opacity: 0.8;
  }

  @media (min-width: ${BreakpointsEnum.lgm}px) {
    width: auto;
  }
`;

const SubText = styled.div`
  ${TYPO.caption1}
  color: ${COLORS.caption};
  margin-top: 12px;

  @media (min-width: ${BreakpointsEnum.lgm}px) {
    margin-top: 20px;
  }
`;
